// ============================================================
// EmailFormOverlay — E-Mail-Formular des Voice-Pfads (React-Insel).
// Ersetzt #ab-email-overlay aus AssistantBar.js; Sichtbarkeit + Status
// steuert die Engine (showEmailForm/hideEmailForm/sendEmailNow),
// CSS-Klassen unverändert.
// ============================================================
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '../../lib/useTranslation.ts';
import type { AssistantEngine } from '../../../components/assistant-bar/engine/AssistantEngine.ts';

function EmailFormBody({ engine }: { engine: AssistantEngine }) {
  const t = useTranslation();
  const [email, setEmail] = useState(''); // wie früher: emailInp.value = '' bei jedem Öffnen
  const inputRef = useRef<HTMLInputElement | null>(null);

  // Fokus 250 ms nach dem Sichtbarwerden (wie im alten showEmailForm).
  const visible = !!engine.emailForm && engine.emailForm.visible;
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => { try { inputRef.current?.focus(); } catch { /* wie zuvor */ } }, 250);
    return () => clearTimeout(timer);
  }, [visible]);

  return (
    <div className="ab-email-box">
      <div className="ab-email-title">{t('assistant.emailTitle')}</div>
      <input
        ref={inputRef}
        type="email"
        inputMode="email"
        autoComplete="email"
        autoCapitalize="off"
        spellCheck={false}
        className="ab-email-input"
        id="ab-email-input"
        placeholder="name@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') engine.sendEmailNow(email); }}
      />
      <div className="ab-email-actions">
        <button className="ab-email-cancel" id="ab-email-cancel" onClick={() => engine.hideEmailForm()}>{t('common.cancel')}</button>
        <button className="ab-email-send" id="ab-email-send" onClick={() => engine.sendEmailNow(email)}>{t('assistant.send')}</button>
      </div>
      <div className="ab-email-status" id="ab-email-status">{engine.emailForm?.status || ''}</div>
    </div>
  );
}

export function EmailFormOverlay({ engine }: { engine: AssistantEngine }) {
  const form = engine.emailForm;
  if (!form) return null;
  return (
    <div
      className="ab-email-overlay"
      id="ab-email-overlay"
      style={{ display: form.visible ? 'flex' : 'none' }}
      onClick={(e) => { if (e.target === e.currentTarget) engine.hideEmailForm(); }}
    >
      {/* key=seq: jedes showEmailForm startet mit leerem Feld (wie früher) */}
      <EmailFormBody key={form.seq} engine={engine} />
    </div>
  );
}
